import { render, staticRenderFns } from "./select-users.vue?vue&type=template&id=ff3df972"
import script from "./select-users.vue?vue&type=script&lang=js"
export * from "./select-users.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./select-users.vue?vue&type=style&index=1&id=ff3df972&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports